import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as filters from "./fliters";
import "./static/css/public.css";
import "./static/js/public.js";
import "element-ui/lib/theme-chalk/index.css";
import Element from "element-ui";
import noneBox from "./views/component/noneBox.vue";
import fun from "./static/js/fun";
import "@/utils/vant.js";

import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import hls from "videojs-contrib-hls";

Vue.use(hls);
Vue.use(VideoPlayer);

import store from "./store/store";

Vue.prototype.$store = store;
Vue.prototype.$fun = fun;

window.router = router;
router.afterEach((to) => {
  const u = navigator.userAgent.toLowerCase();
  if (
    u.indexOf("like mac os x") < 0 ||
    u.match(/MicroMessenger/i) != "micromessenger"
  ) {
    return;
  } else {
    if (to.path !== global.location.pathname) {
      location.assign(to.fullPath);
    }
  }
});

Vue.config.productionTip = false;
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.use(Element);
Vue.component("noneBox", noneBox);
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
